window.CASES = {
  "aman-nai-lert-bangkok": {
    "id": "aman-nai-lert-bangkok",
    "title": "Aman Nai Lert, Bangkok",
    "category": "Hotels",
    "location": "Nai Lert Park, Bangkok, Thailand",
    "year": "2025",
    "materials": "21Parkhouse® Yamagate Weaving Series (Standard White)",
    "application": "Interior Walls",
    "summary": "Aman Nai Lert Bangkok uses 21Parkhouse® Flexible Stone as an interior wall finish, translating bamboo texture and light-and-shadow details into a calm urban sanctuary.",
    "detail": "The project deconstructs traditional Thai aesthetics into minimalist lines, natural materials and a narrative of light and shadow. The designers incorporated 21Parkhouse® Flexible Stone as the interior wall finish, allowing the bamboo texture to flow between solid and void while meeting Class A fire-resistance needs.",
    "sourceUrl": "/service/aman-nai-lert-bangkok.html"
  },
  "poly-rosewood-sanya-hotel": {
    "id": "poly-rosewood-sanya-hotel",
    "title": "Poly Rosewood Sanya Hotel",
    "category": "Hotels",
    "location": "Haitang District, Sanya, Hainan",
    "year": "2017",
    "materials": "21Parkhouse® Customized Wood, Matsue W Weaving, Sicily Line Stone, K Brick",
    "application": "Lobby, Guest Rooms, Restaurants, SPA Shower Rooms, Building Facade",
    "summary": "Rosewood Sanya applies 21Parkhouse® Flexible Stone across walls, ceilings and high-humidity spaces, using wood, weaving, line stone and brick textures for a coastal luxury hotel setting.",
    "detail": "The hotel uses wood grain, weaving and masonry textures to build a natural coastal atmosphere. 21Parkhouse® Flexible Stone helps replace traditional wood and hemp textures in high-humidity hotel areas while preserving the intended warm, natural aesthetic.",
    "sourceUrl": "/service/poly-rosewood-sanya-hotel.html"
  },
  "private-villa-omsk-russia": {
    "id": "private-villa-omsk-russia",
    "title": "Private Villa in Omsk, Russia",
    "category": "Cases",
    "location": "Omsk, Russia",
    "year": "2024",
    "materials": "21Parkhouse® Glacier texture, Kiln texture",
    "application": "Exterior Walls",
    "summary": "This private villa uses 21Parkhouse® Flexible Stone on exterior walls, including Glacier texture, to combine natural charm with weather-resistant exterior performance.",
    "detail": "The villa project selected Flexible Stone as the main material for exterior walls. Glacier texture is used on exterior walls, while the material supports freeze-thaw resistance, aging resistance and a refined modern-natural façade effect.",
    "sourceUrl": "/service/private-villa-in-omsk-russia.html"
  },
  "shanghai-goeasy-brand-experience-space": {
    "id": "shanghai-goeasy-brand-experience-space",
    "title": "Shanghai GOEASY Brand Experience Space",
    "category": "Cases",
    "location": "Shanghai, China",
    "year": "2023",
    "materials": "21Parkhouse® Rammed earth wall",
    "application": "Interior wall",
    "summary": "The GOEASY brand experience space uses 21Parkhouse® Flexible Stone rammed earth wall board with primitive wood grain to build a natural yet avant-garde commercial interior.",
    "detail": "Designers used original ecological aesthetics and avant-garde design to create a creative, vibrant brand experience space. The combination of 21Parkhouse® Flexible Stone rammed earth wall board and wood grain creates an industrial-natural atmosphere for the interior.",
    "sourceUrl": "/service/shanghai-goeasy-brand-experience-space.html"
  },
  "featured-projects-india": {
    "id": "featured-projects-india",
    "title": "Featured Projects in India",
    "category": "Regional Applications",
    "location": "India",
    "year": "",
    "materials": "21Parkhouse® Flexible Stone",
    "application": "Bathrooms, pool areas, spa rooms, coastal architecture, facades and commercial spaces",
    "summary": "This regional case explains how Flexible Stone supports humid, hot and high-pollution architectural conditions in India with water resistance, aging resistance and lightweight installation.",
    "detail": "The India application case focuses on practical needs such as monsoon humidity, harsh UV exposure, pollution, seismic installation challenges and carbon goals. Flexible Stone is positioned as a wall cladding solution for long-term architectural performance.",
    "sourceUrl": "/service/featured-projects-in-india.html"
  },
  "featured-projects-indonesia": {
    "id": "featured-projects-indonesia",
    "title": "Featured Projects in Indonesia",
    "category": "Regional Applications",
    "location": "Indonesia",
    "year": "",
    "materials": "21Parkhouse® Flexible Stone",
    "application": "Wall cladding in tropical, humid and heavy-rain environments",
    "summary": "This regional case presents Flexible Stone as a durable, eco-friendly and adaptable wall cladding material for Indonesia’s hot, humid and rainy climate.",
    "detail": "The Indonesia application case focuses on tropical UV, humidity, cracking, mildew, transport costs, fire risk and environmental goals. Flexible Stone is positioned for wall cladding under year-round heat, humidity and heavy rain.",
    "sourceUrl": "/service/featured-projects-in-indonesia.html"
  }
};
window.PRODUCT_CASES = {
  "rammed-earth-wall": "shanghai-goeasy-brand-experience-space",
  "glacier-stone": "private-villa-omsk-russia",
  "matsue-w-weaving": "poly-rosewood-sanya-hotel",
  "sicily-ilne-stone": "poly-rosewood-sanya-hotel",
  "k-brick": "poly-rosewood-sanya-hotel",
  "natural-wood": "poly-rosewood-sanya-hotel",
  "shadow-of-bamboo": "aman-nai-lert-bangkok",
  "carved-bamboo-stone": "aman-nai-lert-bangkok",
  "wood-lattice-stone": "aman-nai-lert-bangkok",
  "bjork-linear-timber": "aman-nai-lert-bangkok",
  "kesong-carbonized-wood": "poly-rosewood-sanya-hotel",
  "travertine-pro": "featured-projects-india",
  "coral-travertine-pro": "featured-projects-india",
  "polished-stone-pro": "featured-projects-india",
  "skyline-pro": "featured-projects-india",
  "limestone-pro": "featured-projects-india",
  "sandstone-pro": "featured-projects-india",
  "cretan-travertine-pro": "featured-projects-india",
  "oasis-stone": "featured-projects-indonesia",
  "ocean-travertine": "featured-projects-indonesia"
};
